import { Mutations } from 'vuex-smart-module';
import CartSharedState from './state';

export default class CartSharedMutations extends Mutations<CartSharedState> {
}
